import { lazy } from 'react';
import { REPORT_PERMISSIONS } from './constants';

const ReportsPage = lazy(() => import('./pages/ReportsPage'));

export const reportRoutes = [
  {
    path: '/reports',
    element: ReportsPage,
    permission: REPORT_PERMISSIONS.READ,
    nav: { labelKey: 'nav.reports', icon: 'BarChartOutlined', group: 'system' },
  },
];
